<template>
  <div class="card">
    <div class="card-item flex justify-between p-4 relative">
      <div class="items-end block border-r border-dashed pl-4 pr-10 item-end-sp">
        <div class="w-36 item-name" v-if="is_edit && !is_instant">
          <ValidationProvider
            name="項目名"
            :rules="{
              required: true,
              titleUnique: [template.boxes, boxTarget.box_type],
              maxValue: 100
            }"
              v-slot="{ errors }"
          >
            <el-input
                class="mr-2 w-full h-10"
                :disabled="is_assignment"
                :class="'input-' + key"
                placeholder="項目名"
                :maxlength="100"
                v-model="boxTarget.title"
            >
            </el-input>
            <span class="text-red-500">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <el-button class="mt-4" @click="removeBox" v-if="isPermissionAll">
          <i class="el-icon-delete"></i>
        </el-button>
        <el-button class="mt-4" @click="duplicateBox" v-if="isPermissionAll">
          <i class="el-icon-document-copy"></i>
        </el-button>
      </div>
      <div class="items-end flex w-full item-check flex-wrap">
        <div v-if="Number(box.box_type) === configSquareType.tableCol && box.is_split" class="px-8 label-draw">列割当</div>
        <div v-else-if="Number(box.box_type) === configSquareType.tableCol && !box.is_split" class="px-8 label-draw">行自動認識</div>
        <div v-else-if="Number(box.box_type) === configSquareType.tableRow && box.is_split" class="px-8 label-draw">行割当</div>
        <div v-else-if="Number(box.box_type) === configSquareType.tableRow && !box.is_split" class="px-8 label-draw">列自動認識</div>
        <div v-else-if="[configSquareType.checked, configSquareType.rounded].includes(Number(box.box_type))" class="px-8 label-draw">チェックボックス</div>
        <div v-else-if="Number(box.box_type) === configSquareType.square" class="px-8 label-draw">テキストボックス</div>
        <div class="px-8">
          <textarea
              v-if="boxTarget.showResult || !is_edit"
              class="w-full outline-none border px-2 py-1"
              :rows="2"
              v-model="boxTarget.result"
          >
          </textarea>

          <div
              v-if="box.box_type <= 3 || !box.box_type"
              class="flex justify-between items-end gap-4 mt-4 mx-auto item-check__detail"
          >
            <el-select
                v-model="boxTarget.charset"
                filterable
                placeholder="文字種を選択"
                class="w-full"
            >
              <el-option
                  v-for="item in charsetList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
              >
              </el-option>
            </el-select>
            <el-select
                v-model="boxTarget.engine"
                filterable
                placeholder="OCRエンジンを選択"
                class="w-full"
            >
              <el-option
                  v-for="item in engineList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
              >
              </el-option>
            </el-select>

            <div v-if="(Number(box.box_type) === configSquareType.tableCol || Number(box.box_type) === configSquareType.tableRow) && box.is_split " class="w-full mt-4 custom__column">
              <span class="custom__column__title">セル数</span>
                <ValidationProvider
                    class="custom__column__input"
                    name="セル数"
                    :rules="{
                      required: true,
                      min_number: 2
                     }" v-slot="{ errors }">
                  <el-input type="text" @keypress.native="handleNumber"
                            @blur.native="handleNumber"
                            @keyup.native="handleNumber" maxlength="3"  v-model="boxTarget.n_lines"/>
                  <div class="text-red-500">{{ errors[0] }}</div>
                </ValidationProvider>
            </div>

            <!-- TABLE COL - ROW -->
            <!--
            <div
              v-if="
                box.box_type == configSquareType.tableRow ||
                  box.box_type == configSquareType.tableCol
              "
              class="mt-4 flex items-center"
            >
              <p class="mr-1 whitespace-nowrap">
                {{
                  box.box_type == configSquareType.tableRow ? "行数" : "列数"
                }}
              </p>
               <el-input v-model="elNumber" />
              <el-input
                class="w-full"
                :class="'input-' + key"
                v-model="boxTarget.n_lines"
              />
            </div>
            -->
          </div>

          <div v-if="box.box_type >= 4" class="w-full mt-4">
            <el-select v-model="valueSelected" filterable placeholder="Select">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="flex items-end item-update">
<!--        <el-button-->
<!--            class="btn-main px-4"-->
<!--            type="warning"-->
<!--            v-if="boxTarget.type !== configSquareType.checked"-->
<!--            @click="openModalAdd"-->
<!--        >-->
<!--         -->
<!--        </el-button>-->
        <el-button
            v-if="isPermissionAll"
            class="btn-main px-4"
            type="warning"
            :loading="loading"
            @click="is_assignment ? runAssignment() : _runOcr()"
        >
          読取確認
        </el-button>
      </div>
      <svg  v-if="isPermissionAll" width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg"
           @click="openModalAdd" class="setting__map">
        <path @click="openModalAdd" d="M21.4371 14.6253L19.8154 13.2388C19.8921 12.7684 19.9318 12.2881 19.9318 11.8078C19.9318 11.3275 19.8921 10.8472 19.8154 10.3768L21.4371 8.99031C21.5594 8.88559 21.6469 8.74613 21.688 8.59046C21.7292 8.43478 21.7219 8.27028 21.6673 8.11881L21.645 8.05444C21.1986 6.80669 20.5301 5.65 19.6718 4.64027L19.6272 4.58828C19.5231 4.46585 19.3843 4.37785 19.2292 4.33586C19.0741 4.29388 18.9099 4.29988 18.7582 4.35308L16.7454 5.06859C16.0026 4.45954 15.1732 3.97923 14.277 3.64251L13.8883 1.53806C13.8589 1.37971 13.7821 1.23403 13.668 1.12038C13.5539 1.00673 13.4079 0.93048 13.2495 0.901769L13.1826 0.88939C11.8927 0.656662 10.536 0.656662 9.24607 0.88939L9.17922 0.901769C9.02076 0.93048 8.87479 1.00673 8.76069 1.12038C8.6466 1.23403 8.56979 1.37971 8.54046 1.53806L8.14928 3.65242C7.26018 3.9892 6.43221 4.46926 5.69821 5.07354L3.6705 4.35308C3.5189 4.29945 3.35456 4.29324 3.19934 4.33525C3.04412 4.37726 2.90535 4.46551 2.80149 4.58828L2.75692 4.64027C1.89965 5.65072 1.23125 6.80721 0.783684 8.05444L0.761401 8.11881C0.649989 8.42829 0.741595 8.77491 0.991653 8.99031L2.63313 10.3916C2.55638 10.8571 2.51924 11.3324 2.51924 11.8053C2.51924 12.2807 2.55638 12.756 2.63313 13.219L0.991653 14.6203C0.869337 14.7251 0.781793 14.8645 0.740664 15.0202C0.699534 15.1759 0.706767 15.3404 0.761401 15.4918L0.783684 15.5562C1.23181 16.804 1.89533 17.9553 2.75692 18.9704L2.80149 19.0224C2.9056 19.1448 3.04437 19.2328 3.19951 19.2748C3.35464 19.3168 3.51885 19.3108 3.6705 19.2576L5.69821 18.5371C6.436 19.1437 7.26045 19.624 8.14928 19.9582L8.54046 22.0726C8.56979 22.2309 8.6466 22.3766 8.76069 22.4903C8.87479 22.6039 9.02076 22.6802 9.17922 22.7089L9.24607 22.7213C10.5478 22.9552 11.8809 22.9552 13.1826 22.7213L13.2495 22.7089C13.4079 22.6802 13.5539 22.6039 13.668 22.4903C13.7821 22.3766 13.8589 22.2309 13.8883 22.0726L14.277 19.9681C15.1728 19.6323 16.0069 19.1504 16.7454 18.5421L18.7582 19.2576C18.9098 19.3112 19.0741 19.3174 19.2294 19.2754C19.3846 19.2334 19.5234 19.1451 19.6272 19.0224L19.6718 18.9704C20.5334 17.9528 21.1969 16.804 21.645 15.5562L21.6673 15.4918C21.7787 15.1873 21.6871 14.8407 21.4371 14.6253ZM18.0575 10.6689C18.1194 11.0428 18.1516 11.4265 18.1516 11.8103C18.1516 12.194 18.1194 12.5778 18.0575 12.9516L17.8941 13.9444L19.7436 15.5265C19.4632 16.1724 19.1093 16.7839 18.6889 17.3487L16.3913 16.5342L15.6139 17.1729C15.0222 17.6582 14.3636 18.0395 13.6506 18.3069L12.7073 18.6609L12.2641 21.0625C11.5649 21.1417 10.8589 21.1417 10.1597 21.0625L9.71648 18.6559L8.78061 18.297C8.075 18.0296 7.41891 17.6483 6.83214 17.1655L6.05473 16.5243L3.7423 17.3462C3.32141 16.7793 2.96984 16.1677 2.6876 15.524L4.55685 13.9271L4.39592 12.9368C4.3365 12.5679 4.30431 12.1866 4.30431 11.8103C4.30431 11.4315 4.33402 11.0527 4.39592 10.6838L4.55685 9.69344L2.6876 8.09653C2.96737 7.45034 3.32141 6.84128 3.7423 6.27432L6.05473 7.0963L6.83214 6.45506C7.41891 5.97227 8.075 5.59099 8.78061 5.3236L9.71895 4.96956L10.1621 2.56305C10.8578 2.48382 11.5684 2.48382 12.2666 2.56305L12.7098 4.96461L13.653 5.31865C14.3636 5.58604 15.0247 5.96732 15.6164 6.45258L16.3938 7.09134L18.6914 6.2768C19.1123 6.84376 19.4638 7.45529 19.7461 8.09901L17.8966 9.68106L18.0575 10.6689ZM11.2168 7.20523C8.81032 7.20523 6.85937 9.15619 6.85937 11.5627C6.85937 13.9692 8.81032 15.9202 11.2168 15.9202C13.6233 15.9202 15.5743 13.9692 15.5743 11.5627C15.5743 9.15619 13.6233 7.20523 11.2168 7.20523ZM13.1777 13.5236C12.9205 13.7815 12.6149 13.986 12.2783 14.1254C11.9418 14.2647 11.5811 14.3362 11.2168 14.3356C10.4766 14.3356 9.78085 14.046 9.25597 13.5236C8.99805 13.2664 8.79352 12.9607 8.65416 12.6242C8.51479 12.2877 8.44333 11.9269 8.4439 11.5627C8.4439 10.8224 8.73357 10.1267 9.25597 9.60184C9.78085 9.07696 10.4766 8.78976 11.2168 8.78976C11.9571 8.78976 12.6528 9.07696 13.1777 9.60184C13.4356 9.85902 13.6401 10.1647 13.7795 10.5012C13.9189 10.8377 13.9903 11.1985 13.9898 11.5627C13.9898 12.303 13.7001 12.9987 13.1777 13.5236Z" fill="#7B7B7B"/>
      </svg>
    </div>
    <el-dialog title="" :visible.sync="showPopupAdd" :show-close="true" @close="cancelGround" :close-on-click-modal="false" class="ocr-dialog popup-edit">
      <div slot="title" class="title-popup-edit mt-5">データの変換</div>
      <div class="">
        <div class="mt-4 mb-3">このフィールドが受け入れることができる値のリストを以下のいずれかのフォーマット通りに入力してください</div>
        <div class="title-note"><span>フォーマット1：</span>システムは値のリスト内OCRエンジンの読取値に最も近いターゲット値の1つを返す。 </div>
        <div class="title-error">ターゲット値 1</div>
        <div class="title-error">ターゲット値 2</div>
        <div class="title-error">…</div>
        <div class="title-error mb-3">ターゲット値 N</div>
        <div class="title-note"><span>フォーマット2：</span>システムは値のリスト内OCRエンジンの読取値に最も近い当該キーの ターゲット値の1つを返す。 </div>
        <div class="title-error">キー値 1, ターゲット値 1</div>
        <div class="title-error">キー値 1, ターゲット値 1</div>
        <div class="title-error">…</div>
        <div class="title-error mb-3">キー値 N, ターゲット値 N</div>
        <div>
            <div class="">
              <el-input type="textarea" :rows="6" v-model="boxTarget.ground_truth"></el-input>
            </div>
            <div class="mt-4">またはCSVファイルでまとめてアップロードしてください。</div>
            <el-button @click="selectFile" class="w-auto ocr-button ocr-button-default leading-1 mt-4">
              CSVファイルを選択
            </el-button>
            <input
                type="file"
                @change="chooseFile"
                ref="selectFile"
                class="hidden"
                accept="text/csv"
                multiple
            />
          </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="ocr-button ocr-button-default" @click="cancelGround">
          キャンセル
        </el-button>
        <el-button type="danger" class="btn-main ocr-button" @click="acceptedGround">
           保存
        </el-button>
      </span>
    </el-dialog>
    <hr/>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {configSquareType} from "@/config/squareType";

export default {
  props: [
    "inputs",
    "template",
    "index",
    "box",
    "templateId",
    "is_edit",
    "is_instant",
    "is_assignment",
    "assignmentBox",
    "isPermissionAll",
  ],

  data: function () {
    return {
      options: [
        {
          value: "4",
          label: "ティック",
        },
        {
          value: "5",
          label: "サークル",
        },
      ],
      valueSelected: "4",
      elNumber: 1,
      showPopupAdd: false,
      configSquareType,
      select: {
        select1: null,
        select2: null,
      },
      charset: [],
      bodyStyle: {
        border: "solid 2px green",
      },
      model: "",
      title: "",
      showResult: false,
      resultOcr: "",
      cropImage: "",
      debug: process.env.VUE_APP_DEBUG,
      loading: false,
      assignment_ground_truth: "",
      ground_truth: ''
    };
  },

  watch: {
    charset: {
      deep: true,
      handler: function (value) {
        this.boxTarget.charset = value;
        this.$emit("box-value", {
          box: this.boxTarget,
          index: this.index,
        });
      },
    },

    assignment_ground_truth: function () {
      this.boxTarget.ground_truth = this.assignment_ground_truth;
    },

    valueSelected(newValue) {
      this.boxTarget.box_type = newValue;
    },
  },

  computed: {
    ...mapState({
      charsetList: (state) => state.charset.charsets,
      engineList: (state) => state.engine.engines,
    }),

    boxTarget: {
      get: function () {
        return this.box;
      },
      set: function (value) {
        return value;
      },
    },
    key: function () {
      return this.index;
    },
  },

  created: function () {
    if (this.is_assignment) {
      this.box.active = false;
    }
    if (this.boxTarget.box_type) {
      this.valueSelected = this.boxTarget.box_type.toString();
      this.ground_truth = this.boxTarget.ground_truth;
    }
  },

  methods: {
    openModalAdd() {
      this.showPopupAdd = true
    },
    cancelGround() {
      this.boxTarget.ground_truth = this.ground_truth
      this.showPopupAdd = false
    },
    acceptedGround() {
      this.ground_truth = this.boxTarget.ground_truth
      this.showPopupAdd = false
    },
    async chooseFile(event) {
      this.file = event.target.files ? event.target.files[0] : null;
      if (this.file) {
        await this.$papa.parse(this.file, {
          header: false,
          complete: (results) => {
           const data = results.data.map((result) => {
               return result.join()
            })
            this.boxTarget.ground_truth = data.join('\n')
          },
        })
      }
    },
    selectFile() {
      return this.$refs.selectFile.click()
    },
    handleNumber(event) {
      if (this.inputValue !== null && this.inputValue instanceof String) {
        this.inputValue = this.inputValue.toString().replace(/[^\d].+/, '')
      }
      if ((event.which < 48 || event.which > 57)) {
        event.preventDefault()
      }
    },
    removeBox: function () {
      this.boxTarget.is_delete = true;
      this.$emit("remove-box", this.boxTarget);
    },
    duplicateBox: function () {
      this.$emit("add-box", this.boxTarget);
    },

    _runOcr: async function () {
      this.loading = true;
      let response = await this.$store.dispatch("ocr/runOcr", {
        id: this.templateId,
        box: JSON.stringify(this.boxTarget),
      });
      if (response) {
        this.boxTarget.image_path =
            process.env.VUE_APP_BACK_END_URL + "/" + response.image;
        this.boxTarget.result = "";
        if (Array.isArray(response.result)) {
          response.result.forEach((result) => {
            this.boxTarget.result += result + "\r\n";
          });
        } else {
          this.boxTarget.result = response.result;
        }
        this.boxTarget.showResult = true;
      }
      this.loading = false;
    },

    runAssignment: async function () {
      let response = await this.$store.dispatch("assignment/runAssignment", {
        id: this.templateId,
        box: this.assignmentBox,
      });
      if (response) {
        if (Array.isArray(response.result))
          response.result = response.result.join("\r\n");
        this.assignment_ground_truth = response.result;
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.popup-edit .el-dialog__header {
  padding: 20px 20px 20px 0!important;
}
.title-error {
  color: red;
  font-weight: 300;
  font-size: 14px;
}
.title-note {
  font-size: 14px;
}
.title-note > span {
  font-weight: bold;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.selected-card {
  background: #e7f3e9;
}

.title-input {
  padding: 5px 10px;
  border-radius: 4px;
  outline: none;
  width: 120px !important;
}
.custom__column {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.custom__column__title {
  width: 40%;
  min-width: 30px;
}
.custom__column__input {
  width: 60%;
  min-width: 50px;
}
.setting__map {
  position: absolute;
  right: 0;
  top: 10px;
  cursor: pointer;
  width: 60px;
}
/deep/.el-dialog {
  width: 480px;
  padding: 0 20px;
  max-width: 100%;
  //border-radius: 10px;
}
.el-dialog__wrapper {
  padding: 15px;
}
.title-popup-edit {
  font-weight: bold;
  font-size: 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid darkblue;
}

.label-draw{
  width: 100%;
}

@media screen and (min-width: 998px) and (max-width: 1200px) {
  .item-check__detail {
    flex-wrap: wrap;

    .custom__column__title {
      width: 100%;
      margin-bottom: 10px;
    }
    .custom__column__input {
      width: 100%;
    }
  }
}

@media screen and (max-width: 820px) {
  .card-item {
    padding: 15px 0;
  }
}

@media screen and (max-width: 767px) {
  .card-item {
    padding: 0;
    //align-items: center;
    flex-wrap: wrap;
    display: flex;
  }
  .item-end-sp {
    align-items: center;
    width: 40%;
  }
  .item-name {
    width: 100%;
  }
  .item-check {
    width: 40%;
  }
  .item-check > .px-8 {
    padding: 0 10px;
  }
  .item-update {
    width: 20%;
  }
  .card-item > /deep/ .el-input__inner {
    border-radius: 8px;
  }
  .item-check__detail {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    margin-top: unset;
  }
  .content-sp /deep/ textarea, /deep/ .el-select, /deep/ .el-input, /deep/ .el-input__inner {
    border-radius: 8px;
  }
  .item-update {
    align-items: center;
    min-width: 62px;
  }
  .item-update > .el-button {
    white-space: inherit;
    border-radius: 8px;
    line-height: 18px;
    min-width: 62px;
  }
  .card-item > .item-check, .card-item > .item-update, .card-item > .item-end-sp {
    padding: 15px 10px 15px 0;
  }

  .label-draw {
    margin-bottom: 10px;
  }
}
</style>
